import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    imports: [IconCustomComponent],
    selector: 'ms-popular-bets-module-header',
    templateUrl: './popular-bets-module-header.component.html',
    styleUrls: ['./popular-bets-module-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularBetsModuleHeaderComponent {
    @Input() title: string;
    @Input() titleIconClass: string;
}
